module.exports = {
  VirtualTour: {
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    Coords: "Coordinates",
    opacity: "Opacity",
    padding: "Padding",
    PluginName: "Google Map",
    radius: "Radius",
    center: "Center",
    Zoom: "Zoom",
    map: "Mapa",
    message_mark_xy:
      "You've chosen an incorrect value. You must introduce two numbers separated by a comma. E.g. 4.56,90.76",
    message_mark_xyp:
      "You've chosen an incorrect value. You must introduce three numbers separated by a comma. E.g. 4.56,90.76,1",
    Search: "Search places...",
  },
};
